import { colors } from '../../colors';
var pagination = {
  activeColor: colors.copper,
  defaultColor: colors.lead
};
export default pagination;